import * as React from 'react'
import styled from '@theme/styled-components'

import { View } from 'react-native'
import SVG from 'react-inlinesvg'

interface Props {
  name: SiteIconName
  color?: string
  height?: number
  width?: number
}

const VIEWBOX_HEIGHT = 533
const VIEWBOX_WIDTH = 800

const icons: { [key in SiteIconName]: string } = {
  CDL: require('./sites-svg/CDL.svg'),
  CHAMP: require('./sites-svg/CHAMP.svg'),
  EGARCHE: require('./sites-svg/EGARCHE.svg'),
  HSR: require('./sites-svg/HSR.svg'),
  PCI: require('./sites-svg/PCI.svg'),
  PCP: require('./sites-svg/PCP.svg'),
  PCV: require('./sites-svg/PCV.svg'),
  PDV: require('./sites-svg/PDV.svg'),
  PLB: require('./sites-svg/PLB.svg'),
  PNV: require('./sites-svg/PNV.svg'),
  CNIT2: require('./sites-svg/CNIT2.svg'),
}

const SiteIcon = ({ name = 'CDL', color, height = 20, width }: Props) => {
  const iconSrc = icons[name]

  const iconHeight = width !== undefined ? (width * VIEWBOX_HEIGHT) / VIEWBOX_WIDTH : height
  const iconWidth = width || (height * VIEWBOX_WIDTH) / VIEWBOX_HEIGHT

  return (
    <IconContainer height={iconHeight} width={iconWidth} color={color}>
      <SVG
        src={iconSrc}
        preProcessor={(code) =>
          code.replace(/ width=".*?"/g, ` width="${iconWidth}"`).replace(/height=".*?"/g, `height="${iconHeight}"`)
        }
      />
    </IconContainer>
  )
}

export default SiteIcon

const IconContainer = styled(View)<{ height: number; width: number; color?: string }>`
  height: ${(props) => props.height}px;
  width: ${(props) => props.width}px;
  ${(props) => !!props.color && `color: ${props.color};`}
`
